/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from './@core/utils/analytics.service';
import {NbMenuService} from "@nebular/theme";
import {AuthService} from "./services/auth/auth.service";

@Component({
  selector: 'ngx-app',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {

  constructor(
    private analytics: AnalyticsService,
    private menuService: NbMenuService,
    private auth: AuthService,
  ) {
    this.menuService.onItemClick()
      .subscribe((event) => {
        this.onContecxtItemSelection(event.item.title);
      });
  }

  ngOnInit() {
    this.analytics.trackPageViews();
  }
  onContecxtItemSelection(title: string) {
    if (title === 'Log out') {
      this.auth.signOut();
    }
  }
}
